<template>
  <div>
      <span v-if="this.value" style="color:dodgerblue">
          啟動中
      </span>
      <span v-if="!this.value" style="color:red">
          停用中
      </span>
    <button class="btn btn-danger" @click="disable()" v-if="this.value">停用</button>

    <button class="btn btn-primary" @click="enable()" v-if="!this.value">啟用</button>

  </div>
</template>

<script>
/**
 <MyButtonEnableDisable2 v-model="item.IsEnable"></MyButtonEnableDisable>
 **/


export default {
  // name: "MyColorPicker",
  props: ["value"],
  data: function () {
    return {
      id: "",
      formData: {
        name: "",
      },
      propsValue:this.value,
    };
  },
  watch: {
    propsValue(newVal){
      this.$emit('input', newVal);
    },
    value(newVal){
      this.propsValue = newVal
    }
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    disable(){
      this.value=false;
    },
    enable(){
      this.value=true;
    }
  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
